import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/components/common/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/components/common/OnboardingBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layers/presentation/providers/DocumentParserProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/layers/presentation/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-toastify@10.0.5_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/react-toastify/dist/ReactToastify.css");
